import { useEffect, useRef, useState } from "react";
import MainHeading from "../../../components/comman/MainHeading";
import PlusIcon from "../../../components/Icons/PlusIcon";
import CommonTable from "../../../components/comman/CommonTable";
import FilterComponent from "../../../components/comman/FilterComponent";
import AddItemModal from "./AddItemModal";
import ItemPreviewDrawer from "./ItemPreviewDrawer";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import { toast } from "react-toastify";
import EditIcon from "../../../components/Icons/EditIcon";
import ViewIcon from "../../../components/Icons/ViewIcon";
import { Nav, NavItem, NavLink } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { updateFiltersStates } from "../../../store/actions/UserActions";
import SearchSiteSelect from "../../../components/comman/SiteSearchSelect";
import {
  ITEM_CATEGORIES,
  decorateItem,
  fetchItemCounts,
} from "./ItemMasterService";
import "./ItemMaster.css";

export default function ItemMaster() {
  const [modal, setModal] = useState({
    updateData: false,
  });
  const [state, setState] = useState({
    itemList: [],
    EditItemData: null,
    previewItem: null,
  });
  const [counts, setCounts] = useState({
    all: 0,
    supply: 0,
    service: 0,
    general: 0,
  });
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    searchQuery: "",
    tableLoader: false,
    sortByDate: "",
    siteId: "",
    user: "",
    type: "",
    status: "",
    isLoadingExpenseHead: false,
    expenseHeadList: [],
    expenseHeadId: "",
  });
  const timeoutId = useRef(null);
  const dispatch = useDispatch();
  const filterDetails = useSelector((state) => state.root.filtersStates);

  const toggleModal = () => {
    setModal((pre) => ({
      ...pre,
      updateData: !pre.updateData,
    }));
  };

  const toggleTab = (type) => {
    setPageStates((prev) => ({
      ...prev,
      type: type,
      currentPage: 1,
      expenseHeadId: "",
    }));
  };

  useEffect(() => {
    GetItemList();
  }, [
    pageStates?.searchQuery,
    pageStates.currentPage,
    pageStates?.pageSize,
    pageStates?.type,
    pageStates?.status,
    filterDetails?.orderBy,
    pageStates?.expenseHeadId,
  ]);

  useEffect(() => {
    GetExpenseHeadList();
  }, [pageStates?.type]);

  useEffect(() => {
    GetItemCounts();
  }, []);

  const GetItemCounts = () => {
    fetchItemCounts().then((data) => setCounts(data));
  };

  const GetExpenseHeadList = (inputValue) => {
    return new Promise((resolve) => {
      let API = `${apiUrl.get_expense_head}?${pageStates.type ? `type=${pageStates.type}` : ""}${inputValue ? `&search=${inputValue}` : ""}`;
      let options = { method: "GET" };

      setPageStates((prev) => ({
        ...prev,
        isLoadingExpenseHead: true,
      }));

      callApi(API, options)
        .then((response) => {
          if (response?.status) {
            const formattedData = response?.data?.expenseHead.map(
              (expense) => ({
                value: expense.id,
                label: expense.name,
              })
            );

            setPageStates((prev) => ({
              ...prev,
              isLoadingExpenseHead: false,
              expenseHeadList: formattedData,
            }));
            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          resolve([]);
        });
    });
  };

  const GetItemList = () => {
    let options = {
      method: "GET",
    };
    const Url =
      apiUrl.get_items +
      MainFilterHandler({
        ...pageStates,
        orderBy: filterDetails?.orderBy,
        expenseHeadId: pageStates?.expenseHeadId,
      });
    setPageStates((pre) => ({
      ...pre,
      tableLoader: true,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
      if (res?.status === true) {
        const newData = res?.data?.item?.map((item) => {
          const decorated = decorateItem(item);
          return {
            ...decorated,
            expenseHead: item?.expensehead?.name,
            itemType:
              item?.stockType === 1 ? "Consumeable Assets" : "Fixed Assets",
            nameSubtitle: [decorated?.make, item?.expensehead?.name]
              .filter(Boolean)
              .join(" · "),
            categoryBadge: decorated?.category,
            itemStatusBadge: item?.status,
            gstDisplay:
              decorated?.gst !== "" && decorated?.gst !== null
                ? `${decorated?.gst}%`
                : "--",
            rateDisplay:
              decorated?.standardRate !== "" && decorated?.standardRate !== null
                ? `₹ ${decorated?.standardRate}`
                : "--",
          };
        });
        setState((pre) => ({
          ...pre,
          itemList: newData,
        }));
        setPageStates((pre) => ({
          ...pre,
          count: res?.data?.pageInfo?.total,
          totalPages: res?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const handleStatusToggle = (data, status) => {
    const postData = {
      status: !status,
    };

    const options = {
      method: "POST",
      data: postData,
    };
    let API = apiUrl?.update_items + `?itemId=${data?.id}`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        toast.success(response?.message);
        GetItemList();
        setState((pre) => ({
          ...pre,
          previewItem:
            pre.previewItem?.id === data?.id
              ? { ...pre.previewItem, status: !status, itemStatusBadge: !status }
              : pre.previewItem,
        }));
      } else {
        toast.error(response?.message);
      }
    });
  };

  const TableHeading = [
    { value: "itemPhoto", label: "Photo" },
    { value: "code", label: "Item Code" },
    { value: "itemNameSub", label: "Item Name" },
    { value: "categoryBadge", label: "Category" },
    { value: "unit", label: "UOM" },
    { value: "gstDisplay", label: "GST %" },
    { value: "rateDisplay", label: "Std. Rate" },
    { value: "itemStatusBadge", label: "Status" },
  ];

  const handleEdit = (data) => {
    setState((pre) => ({ ...pre, EditItemData: data, previewItem: null }));
    toggleModal();
  };

  const handlePreview = (data) => {
    setState((pre) => ({ ...pre, previewItem: data }));
  };

  const closePreview = () => {
    setState((pre) => ({ ...pre, previewItem: null }));
  };

  const ActionData = [
    {
      label: "Preview",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "preview",
      clickHandler: handlePreview,
    },
    {
      label: "Edit",
      className: "btn btn-link",
      icon: <EditIcon />,
      title: "edit",
      clickHandler: handleEdit,
    },
  ];

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value,
        currentPage: 1,
      }));
    }, 300);
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1,
    }));
  };

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      })
    );
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  // NOTE: `status` param needs backend support on scm/get-item
  const statusFilterHandler = (e) => {
    setPageStates((prev) => ({
      ...prev,
      status: e.target.value,
      currentPage: 1,
    }));
  };

  const statusFilterList = [
    { value: "", name: "All Status" },
    { value: "true", name: "Active" },
    { value: "false", name: "Inactive" },
  ];

  const handleSortData = (data) => {
    setPageStates((prev) => ({
      ...prev,
      expenseHeadId: data?.expenseHeadId,
      currentPage: 1,
    }));
  };

  const sortList = {
    isShow: true,
    autoSiteSelector: () => {
      return (
        <SearchSiteSelect
          style={{ minWidth: "25rem" }}
          value={pageStates?.expenseHeadId}
          options={pageStates?.expenseHeadList}
          onSelect={(val) => {
            handleSortData({ expenseHeadId: val.value }, "site");
          }}
          onSearch={(input) => {
            GetExpenseHeadList(input);
          }}
          isLoading={pageStates.isLoadingExpenseHead}
          placeholder="Select Group"
        />
      );
    },
  };

  const refreshAfterChange = () => {
    GetItemList();
    GetItemCounts();
  };

  const tabList = [
    { type: "", label: "All", countKey: "all" },
    ...ITEM_CATEGORIES.map((cat) => ({
      type: cat.type,
      label: cat.label,
      countKey: cat.key,
    })),
  ];

  return (
    <>
      <div className="content">
        <MainHeading
          title={"Item Master"}
          buttonText={"Add Item"}
          clickHandler={toggleModal}
          buttonIcon={<PlusIcon />}
        />
        <Nav tabs className="nav nav-tabs border-0 mb-4">
          {tabList.map((tab, index) => (
            <NavItem className="nav-item" key={tab.label}>
              <NavLink
                className={`btn btn-outline-primary px-5 ${index === 0
                  ? "rounded-start-2 rounded-end-0 border-end-0 border-start-2"
                  : index === tabList.length - 1
                    ? "rounded-start-0 rounded-end-2 border-end-2 border-start-0"
                    : "rounded-start-0 rounded-end-0 border-end-0 border-start-0"
                  } ${pageStates?.type === tab.type ? "active" : ""}`}
                style={{ cursor: "pointer" }}
                onClick={() => toggleTab(tab.type)}
              >
                {tab.label}
                <span className="erp-tab-count">{counts[tab.countKey]}</span>
              </NavLink>
            </NavItem>
          ))}
        </Nav>
        <div className="card">
          <div className="card-body">
            <FilterComponent
              handleSearch={handleSearchChange}
              orderByHandler={orderByHandler}
              orderByList={orderByList}
              orderByStatus={statusFilterHandler}
              orderByStatusList={statusFilterList}
              pageStates={pageStates}
              filterArray={sortList}
            />
            <CommonTable
              TableHeading={TableHeading}
              TableData={state?.itemList}
              ActionData={ActionData}
              currentPage={pageStates?.currentPage}
              PageChangeHandler={PageChangeHandler}
              isLoading={pageStates?.tableLoader}
              totalPages={pageStates?.totalPages}
              count={pageStates?.count}
              handleStatusToggle={handleStatusToggle}
              handleChangePageSize={handleChangePageSize}
              pageSize={pageStates.pageSize}
            />
          </div>
        </div>
      </div>
      <AddItemModal
        isOpen={modal.updateData}
        onClose={toggleModal}
        EditItemData={state?.EditItemData}
        setState={setState}
        getItems={refreshAfterChange}
        itemList={state?.itemList}
      />
      <ItemPreviewDrawer
        item={state?.previewItem}
        onClose={closePreview}
        onEdit={handleEdit}
        onToggleStatus={handleStatusToggle}
      />
    </>
  );
}
